"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardSection = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CardSectionMixin = require("../../mixins/components/CardSectionMixin");
/**
 * @since 4.1.0
 */

var CardSection = /*#__PURE__*/_styledComponents.default.section.withConfig({
  displayName: "CardSection",
  componentId: "c11n-8-107-0__sc-10rcp1p-0"
})(["", ""], _CardSectionMixin.CardSectionMixin);
exports.CardSection = CardSection;
CardSection.displayName = 'CardSection';

/** @component */